<template>
  <transition name="popup">
    <div class="popup_wrapper" v-show="flag">
      <div class="popup" :class="{ 'fade-in': isShow && !isDrawer, 'fade-out': !isShow && !isDrawer }" style="width: 330px;">
        <div class="head">
          <div>
            <img src="@/assets/images/关闭按钮.png" alt="" data-close @click="_close">
          </div>
        </div>
        <div class="main">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
    isDrawer:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    flag() {
      if (this.flag) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = 'auto';
      }
    }
  },
  data() {
    return {
      isShow: true,
    }
  },
  mounted() {
  },
  methods: {
    _close(e) {
      const type = e.target.dataset.close;
      if (type === undefined) {
        return
      }
      this.isShow = false;
      setTimeout(() => {
        this.isShow = true;
        this.$emit('close', false);
      }, 200)
    }
  },
}
</script>

<style lang="scss" scoped>
@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  100% {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
}

.fade-in {
  animation: fade-in .3s ease;
}

.fade-out {
  opacity: 0;
  transform: translate3d(0, -100%, 0);
  animation: fade-out .3s ease;
}

@keyframes popup-mask-fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes popup-mask-fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.popup-enter {
  animation: popup-mask-fade-in .3s ease;
}

.popup-leave {
  animation: popup-mask-fade-out .1s ease forwards;
  transform: translate3d(0, -10%, 0);
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0;
}

.popup-enter-active {
  animation: popup-mask-fade-in .3s ease;
}

.popup-leave-active {
  animation: popup-mask-fade-out .1s ease forwards;
  transform: translate3d(0, -10%, 0);
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0;
}

.popup_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.2);
  transition: all .3s;

  .popup {
    position: relative;
    box-sizing: border-box;
    margin: 15vh auto 0;
    // background: #fff;
    border-radius: 6px;
    // box-shadow: 0 1px 3px rgba(0,0,0,.3);
    transition: all .3s;

    .head {
      position: relative;
      height: 40px;

      div {
        position: absolute;
        right: -20px;
        top: 0;
        img {
          width: 30px;
          height: 30px;
          cursor: pointer;
        }
      }
    }

    .main {
      box-sizing: border-box;
      padding: 0 30px 35px;
    }
  }
}
</style>